export default {"src":"/_next/static/media/app.093ad86a.svg","height":650,"width":866,"blurWidth":0,"blurHeight":0};